import React from 'react';
import UploadTrackForm from '../../components/organism/UploadTrackForm/UploadTrackForm';

function UploadTrack() {
  return (
    <main style={{ padding: '1.5em' }}>
      <h1 className="heading1">Upload</h1>
      <UploadTrackForm />
    </main>
  );
}

export default UploadTrack;
